// "Tech I love" (/things) page chrome. The chapter content itself (titles,
// categories, leads, body paragraphs, media captions) lives in
// src/components/things/thingsData.ts, not here.
//
// `updated`: bump this whenever the chapter list is meaningfully updated.
const things = {
  seoTitle: 'Tech I love',
  seoDescription:
    'A living, chaptered write-up of the tech Eduard Hvizdak loves and uses every day: MacBook Pro M4 Pro, Even Realities G1 AR glasses, Kindle, e-ink readers, AirPods Pro 3, Pavlok and more.',
  updated: 'Updated July 2026',
  heroTitle: 'Tech I love',
  heroLead:
    'The gear I actually use every day, one piece at a time. What it is like to live with, what I like and what I do not, and why it earns a permanent spot in my setup. With photos and clips to go with it.',
  chapters: 'Chapters',
  haveALook: 'Have a look',
};

export default things;
